import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent {
  constructor(private translate: TranslateService) {}

  get isArabic(): boolean {
    return (this.translate.currentLang || '').split('-')[0] === 'ar';
  }
}
